import type { MissionListItem } from '../lib/missionCategories'

/** Quantos itens ficam à mostra enquanto a seção está recolhida. */
export const PASS_COLLAPSED_LIMIT = 3

export interface CollapsedSection {
  visibleItems: MissionListItem[]
  /** Quantos itens ficaram de fora — 0 quando nada foi cortado. */
  hiddenCount: number
}

/**
 * Corta os itens de uma seção enquanto ela está recolhida.
 *
 * Só a seção do Passe Mensal recolhe hoje: com 24 objetivos ela empurrava todo
 * o resto do feed para fora da tela na aba "Todas". As demais seções passam
 * `collapsible: false` e atravessam intactas.
 *
 * `hiddenCount` é 0 sempre que nada foi escondido — inclusive quando a seção
 * cabe no limite. É esse zero que decide se o botão "Ver mais objetivos"
 * aparece, então uma seção com 3 itens ou menos nunca ganha o botão.
 */
export function collapseSectionItems(
  items: MissionListItem[],
  {
    collapsible,
    expanded,
    limit = PASS_COLLAPSED_LIMIT
  }: { collapsible: boolean; expanded: boolean; limit?: number }
): CollapsedSection {
  if (!collapsible || expanded) {
    return { visibleItems: items, hiddenCount: 0 }
  }

  const hiddenCount = Math.max(items.length - limit, 0)

  return {
    visibleItems: hiddenCount > 0 ? items.slice(0, limit) : items,
    hiddenCount
  }
}
